import { Component } from '@poa/core';
import React from 'react';
import { action, observable, Observer } from '@poa/state';
import { getProfileIcon } from '../../icons/profile';
import { ProfileTransferModal } from './profile-transfer-modal';


class GeneralTransferProfile extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    localState = observable({
        transfer: null,
        isModalOpen: false,
        accountId: null,
        toOperator: null,
        transferDate: null,
    });

    onModalClose = action(() => {
        this.localState.isModalOpen = false;
        this.localState.transfer = null;
    });

    onModalOpen = action(() => {
        this.localState.isModalOpen = true;
    });

    handleTransferCreate = async (accountId, toOperator, transferDate, profileId) => {
        await this.actions.generalProfileActions.createTransfer({
            accountId,
            toOperator,
            transferDate,
            profileId
        });
        this.onModalClose();
    };

    handleTransferUpdate = async (accountId, toOperator, transferDate, transferId, profileId) => {
        await this.actions.generalProfileActions.updateTransfer({
            transferId,
            accountId,
            toOperator,
            transferDate,
            profileId
        });
        this.onModalClose();
    };

    handleEditTransferModalOpen = (transferId) => {
        const { selectedProfile } = this.store.generalProfile;
        this.localState.transfer = selectedProfile.transfers.find(t => t.id === transferId);
        this.localState.isModalOpen = true;
    }

    render() {

        const { selectedProfile } = this.store.generalProfile;

        return (
            <div className='general_info__content'>
                {
                    selectedProfile.id ?
                        <>
                            <div className='name-row'>
                                <div>
                                    <div className='title-name'>
                                        <button
                                            onClick={this.onModalOpen}
                                            className='create-transfer-button'>
                                            {getProfileIcon('pencil')} Создать Трансфер
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='finance-row'>
                                <div className='info-chart-card'>
                                    <div className='info-header'>
                                        <div className='info-title'>История переводов</div>
                                    </div>
                                    <div className='card-table-header'>
                                        <div className='table-header-name'>Анкета</div>
                                        <div className='table-header-name'>От</div>
                                        <div className='table-header-name'>Кому</div>
                                        <div className='table-header-name'>Дата</div>
                                    </div>
                                    <ul className='card-table'>
                                        {selectedProfile.transfers.map((transfer) => {
                                            return (
                                                <li
                                                    key={transfer.id}
                                                    onClick={() => this.handleEditTransferModalOpen(transfer.id)}>
                                                    <div className='table-row-value'>{transfer.account_name}</div>
                                                    <div className='table-row-name'>{transfer.from_user}</div>
                                                    <div className='table-row-name'>{transfer.to_user}</div>
                                                    <div className='table-row-value'>{transfer.transfer_date}</div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>

                            <Observer>
                                {() => (
                                    <ProfileTransferModal
                                        isOpen={this.localState.isModalOpen}
                                        onRequestClose={this.onModalClose}
                                        transfer={this.localState.transfer}
                                        oldData={selectedProfile}
                                        handleTransferCreate={this.handleTransferCreate}
                                        handleTransferUpdate={this.handleTransferUpdate}
                                    />
                                )}
                            </Observer>
                        </>
                        :
                        <div className='main-row'>
                            <div className='no-profile-found-text'>
                                {getProfileIcon('noUser')}
                                Профиль не найден
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['general-transfers-profile'] })(GeneralTransferProfile);